import React from "react";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE } from "../../config/constants";

const Footer: React.FC = () => {
  return (
    <footer className="bg-rose-900 text-rose-100 py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex flex-col items-center gap-2">
            <img
              src="/Etiqueta Estef's Cakes2.png"
              alt="Estef's Cakes"
              className="h-14 w-auto"
            />
            <p className="font-body text-xs text-rose-300 tracking-widest">
              Endulza tu paladar
            </p>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 font-body text-sm text-rose-300">
            {["Inicio", "Catálogo", "Nosotros", "Contacto"].map((item) => (
              <a
                key={item}
                href={`#${item === "Inicio" ? "home" : item === "Catálogo" ? "catalog" : item === "Nosotros" ? "about" : "contact"}`}
                className="hover:text-white transition-colors">
                {item}
              </a>
            ))}
          </div>

          {/* Social */}
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 bg-rose-800 hover:bg-rose-700 px-4 py-2 rounded-full transition-colors">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
            <span className="font-body text-sm">@{INSTAGRAM_HANDLE}</span>
          </a>
        </div>

        <div className="border-t border-rose-800 mt-8 pt-6 text-center">
          <p className="font-body text-xs text-rose-400">
            © {new Date().getFullYear()} Estef's Cakes · Puerto La Cruz,
            Venezuela · Precios sujetos a cambios sin previo aviso.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
